// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1TZPK","balanceDisclaimer":"posDashboard_balanceDisclaimer__1GGnS"};